<template>
  <div class="productDetail" ref="productDetailRef">  
     <ul>
         <li v-for="(item,index) in list" :key="index" v-show="index==$route.query.idx" @click="go">
             <img :src="item" alt="">
         </li>
     </ul>
     <div style="height:40px;background:#FAFAFA"></div>
  </div>
</template>

<script>
export default {
    data() {
        return {
            list:[
                'https://img.alicdn.com/imgextra/i3/2204194895822/O1CN01s2ZGar1ssWUJSz2oc_!!2204194895822.png',
                'https://img.alicdn.com/imgextra/i3/2204194895822/O1CN01yfccL21ssWUB36vfR_!!2204194895822.png',
                'https://img.alicdn.com/imgextra/i3/2204194895822/O1CN01Hr8uf21ssWUJNe8QV_!!2204194895822.png',
                'https://img.alicdn.com/imgextra/i3/2204194895822/O1CN01ZX3rZG1ssWUKLeG9N_!!2204194895822.png',
                'https://img.alicdn.com/imgextra/i1/2204194895822/O1CN01isOuXF1ssWUTQBDf3_!!2204194895822.png',
                'https://img.alicdn.com/imgextra/i3/2204194895822/O1CN01FrmcnQ1ssWVrliIUp_!!2204194895822.png'
            //    require("../assets/producta1.png"),
            //    require("../assets/producta2.png"),
            //    require("../assets/producta3.png"),
            //    require("../assets/producta4.png"),
            //    require("../assets/producta5.png"),
            //    require("../assets/producta6.png"),
            //    require("../assets/producta7.png"),
            //    require("../assets/producta8.png"),
            //    require("../assets/producta9.png"),
            //    require("../assets/producta10.png"),
            //    require("../assets/producta11.png"),
            //    require("../assets/producta12.png"),
            ]
        }
    },
    methods:{
        go(){
            this.$router.push('/product')
        }
    },
    created() {
        console.log(this.$route.query.idx)
        window.scrollTo(0,0)
        // document.getElementById('productDetailRef').scrollTo
        
    },
}
</script>

<style scoped lang='less'>

.productDetail{
    padding-top: 40px;
    background:#FAFAFA;
    display: flex;
    justify-content: center;
    // height: 100%;
}
</style>